import LockIcon from '@mui/icons-material/Lock';
import { ErrorPage } from './error-page';

export default function PageUnauthorized() {
    return (
        <ErrorPage
            code="401"
            title="Acesso não autorizado"
            message="Para ter acesso a esta área é necessário se autenticar. Utilize a página de login para realizar a autenticação e obter as permissões necessárias."
            icon={<LockIcon />}
            color="warning"
        />
    );
}
